import { normalize } from 'normalizr';

import * as schemas from 'schemas';
import { callApi } from 'utils/api';

export function goalsFetch(query) {
  return callApi('/more/goals', query)
  .then(json => {
    const { goals, meta }  = json;

    // We need to be able to sort the goals
    goals.forEach(goal => {
      goal.updatedAt = new Date(goal.updatedAt);
    });

    const { result, entities } = normalize(goals, schemas.goalsArraySchema);
    return {goalIds: result, entities, meta};
  });

}

export function goalChangeScore(goalId, score, source) {
  return callApi(`/more/goals/${goalId}`, {
    method: 'PATCH',
    body: {
      score,
      source,
      updatedAt: new Date()
    }
  });
}

export function goalCreate(goal, source) {
  return callApi('/more/goals', {
    method: 'POST',
    body: { goal, source }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/goals/api.js
 **/